import React from 'react';
import { Clock } from 'lucide-react';
import { PricingSelector } from './PricingSelector';
export function FinalPricing() {
  return <section className="py-10 md:py-20 px-4 sm:px-6 lg:px-8 bg-cream border-t border-navy/5" data-id="element-50">
      <div className="max-w-5xl mx-auto" data-id="element-51">
        <div className="text-center mb-6 md:mb-10 max-w-2xl mx-auto" data-id="element-52">
          <h2 className="text-2xl md:text-5xl font-bold text-navy mb-3 md:mb-5" data-id="element-53">
            No dejes pasar esta oportunidad.
          </h2>
          <div className="bg-red-50 border border-red-200 rounded-xl md:rounded-2xl p-3 md:p-4 inline-flex flex-col sm:flex-row items-center justify-center gap-2 md:gap-3" data-id="element-54">
            <Clock className="w-4 h-4 md:w-5 md:h-5 text-red-600 flex-shrink-0" data-id="element-55" />
            <div className="text-center sm:text-left text-xs md:text-sm" data-id="element-56">
              <span className="text-red-900 font-bold mr-1 block sm:inline" data-id="element-57">
                El precio de lanzamiento termina pronto.
              </span>
              <span className="text-red-700" data-id="element-58">
                Después sube $8.000 ARS y no vuelve a bajar.
              </span>
            </div>
          </div>
        </div>

        <PricingSelector data-id="element-59" />
      </div>
    </section>;
}